<template>
<button
  v-if="showBtn"
  title="Imprimir documentação de cadastro do ticket."
  class="btn btn-fill btn-icon btn-success"
  @click="handleDocumentsPrint()"
>
  <i class="ti-envelope"></i>
</button>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BtnOpenTicketRegisterDocPrint',
  props: {
    ticket: {
      required: true,
      type: Object
    },
    eventProp: {
      default: () => Object.assign({})
    }
  },

  mounted () {
    if (this.eventProp.hasOwnProperty('_id')) {
      if (this.equatorialTerm(this.eventProp)) {
        this.showBtn = true
      }

      return
    }

    this.fetchEvent(this.ticket.eventId, true)
      .then(event => {
        if (this.equatorialTerm(event)) {
          this.showBtn = true
        }
      })
  },

  data () {
    return {
      showBtn: false
    }
  },

  computed: {
    ...mapGetters('project', ['project'])
  },

  methods: {
    ...mapActions('events', { fetchEvent: 'fetchOne', loadingEvent: 'loading' }),

    handleDocumentsPrint () {
      let routeData = this.$router.resolve({
        name: 'tickets.register.print',
        params: { id: this.ticket._id }
      })
      window.open(
        routeData.href,
        'documentsWindow',
        'menubar=false,location=false,resizable=false,scrollbars=1,status=false'
      )
    },

    equatorialTerm (event) {
      return event.doc && event.doc.registerCustomerTicketDocument
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Tickets/Actions/BtnOpenTicketRegisterDocPrint.vue